export default "__VITE_ASSET__319ef877__"